import {IServiceFamilyContent} from "@/model/Content/ServiceFamilyContent"

export interface IHasServiceFamilyContent {
    getServiceFamilyContent(): IServiceFamilyContent | null
    setServiceFamilyContent(content: IServiceFamilyContent): void
}

function hasServiceFamilyContent<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasServiceFamilyContent {
        private content: IServiceFamilyContent | null = null

        constructor(...args: any[]) {
            super(...args);
        }

        public getServiceFamilyContent(): IServiceFamilyContent | null {
            return this.content
        }
        public setServiceFamilyContent(content: IServiceFamilyContent): void {
            this.content = content
        }
    };
}

export default hasServiceFamilyContent